import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CASTING_LINKS } from "@/lib/data";

export default function CastingProfiles() {
    return (
        <section
            id="profiles"
            data-testid="profiles-section"
            className="bg-[#EBE9E4] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-12 md:mb-16">
                    <div className="col-span-12 md:col-span-6">
                        <p className="eyebrow">§ 06</p>
                        <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl mt-3 leading-[0.92] text-[#1A1A1A]">
                            Casting
                            <br />
                            <span className="italic">Profiles</span>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-6 md:pl-12 flex items-end">
                        <p className="text-base md:text-lg text-[#4A4A4A] font-light leading-relaxed max-w-md">
                            Find Vickie's verified credits on industry
                            platforms. Reels, clips, and full credits.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 border-t border-[#1A1A1A]">
                    {CASTING_LINKS.map((link, idx) => (
                        <motion.a
                            key={link.label}
                            href={link.href}
                            target="_blank"
                            rel="noreferrer noopener"
                            data-testid={`profile-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: idx * 0.08 }}
                            className={`group flex items-center justify-between py-10 md:py-14 px-2 md:px-6 border-b border-[#1A1A1A] md:border-b-0 ${
                                idx < CASTING_LINKS.length - 1
                                    ? "md:border-r border-[#1A1A1A]"
                                    : ""
                            } hover:bg-[#1A1A1A] hover:text-[#F7F5F0] transition-colors duration-500`}
                        >
                            <div>
                                <p className="eyebrow group-hover:!text-[#C67C4E] transition-colors duration-500">
                                    {link.note}
                                </p>
                                <h3 className="font-serif-display text-3xl md:text-4xl mt-2 leading-none">
                                    {link.label}
                                </h3>
                            </div>
                            <ArrowUpRight
                                size={28}
                                className="transition-transform duration-500 group-hover:rotate-45 group-hover:text-[#C67C4E]"
                            />
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
}
